const state = () => ({
  username: "",
  theme: "system",
  darkmode: true,
  showOnboarding: true
});

const mutations = {
  setTheme(state, theme) {
    state.theme = theme;
  },
  setShowOnboarding(state, bool) {
    state.showOnboarding = bool;
  },
  rawSetUsername(state, username) {
    state.username = username;
  }
};

const getters = {
  getPersonalGreeting(state) {
    let greeting;
    let exclamation;
    let hour = new Date().getHours();
    console.log(state);
    let username = state.username;

    if (hour < 12 && hour > 5) {
      greeting = "Hyvää huomenta";
      exclamation = true;
    } else if (hour < 18 && hour > 12) {
      greeting = "Iltapäivää";
      exclamation = false;
    }
    if (!greeting) {
      greeting = "Tervehdys";
      exclamation = true;
    }
    if (username) {
      return `${greeting}, ${username}${exclamation ? "!" : ""}`;
    } else {
      return `${greeting}${exclamation ? "!" : ""}`;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters
};
